import { Command } from "@alch/ui";
import useCurrentUser from "@queries/useCurrentUser";
import useTeamSupportUrl from "@queries/useTeamSupportUrl";
import { usePylon } from "@util/analytics/pylon";
import { useEffect } from "react";

interface SupportFABProps {
  /**
   * Hide the support widget when in full screen mode
   */
  hidden: boolean;
}

const SupportFAB = ({ hidden }: SupportFABProps) => {
  const teamSupport = useTeamSupportUrl();
  const { data: user } = useCurrentUser();

  const showPylon = teamSupport.data ? !teamSupport.data.isEnterprise : null;

  // Initialize Pylon chat widget and get hide/show functions
  const { hideChat, showChat } = usePylon({
    enabled: showPylon === true && !hidden,
    user: user
      ? {
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
        }
      : undefined,
  });

  // Handle hidden prop changes
  useEffect(() => {
    if (hidden && showPylon === true) {
      hideChat();
    } else if (!hidden && showPylon === true) {
      showChat();
    }
  }, [hidden, showPylon, hideChat, showChat]);

  if (hidden) {
    return;
  }

  return (
    <>
      {/* A placeholder element to prevent FAB from going over website elements without an option to scroll over it */}
      <div className="h-16" />

      {showPylon === false ? (
        <Command
          as="a"
          target="_blank"
          rel="noreferrer noopener"
          href={teamSupport.data?.url}
          background="dark"
          className="fixed right-5 bottom-5 z-20 flex h-10 w-24 items-center justify-center rounded-full bg-grayscale-950 text-paragraph-100-medium text-white"
        >
          Get Support
        </Command>
      ) : null}
    </>
  );
};

export default SupportFAB;
